import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/initI18n'; // Import our new i18n initialization
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import userScroll from './js/UserScroll';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCJTs4fwIJ6SHucHflQ_NnOwl2y41luZs",
  authDomain: "tensormeweb.firebaseapp.com",
  projectId: "tensormeweb",
  storageBucket: "tensormeweb.appspot.com",
  messagingSenderId: "664902886612",
  appId: "1:664902886612:web:3e03377f7a3c578235c741",
  measurementId: "G-40DXHBBNKB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initial document setup for RTL if needed
const currentLang = localStorage.getItem('i18nextLng') || 'en';
document.documentElement.lang = currentLang;
document.dir = currentLang === 'ar' ? 'rtl' : 'ltr';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

document.addEventListener('DOMContentLoaded', userScroll);
